import styled from 'styled-components'
import { themeFontFamily, themeFontWeight, themeColor } from 'LibNeo'
import { getWidthValue } from 'LibNeo/components/Composite/Grids/ScrollableGrid/GridRow.component'

export const GridHeaderColumnULStyled = styled.ul<{ hideScrollBar?: boolean }>`
	width: 100%;
	background: ${themeColor('white')};
	padding: 12px ${({ hideScrollBar }) => (hideScrollBar ? '20px' : '40px')} 12px 20px;
	border-bottom: 1px solid ${themeColor('gray', 3)};

	display: flex;
	align-items: center;
	margin: 0;
	list-style: none;
	font-family: ${themeFontFamily('SBSansText')};
	font-style: normal;
	font-weight: ${themeFontWeight('SBSansText', 'regular')};
	font-size: 12px;
	color: ${themeColor('gray', 6)};
	gap: 8px;
`

export const GridHeaderColumnLIStyled = styled.li<{ width?: number | string }>`
	${({ width }) => width && getWidthValue(width)};
`
